import { axios } from '@hotmart/request'
import { trace } from 'utils/trace'
import { authService, clearCookies } from './auth.service'
import { LOCALSTORAGE_TOKEN_NAME, generateSSOpathLogout } from './auth.constants'

const appName = require('../../../package.json').name

export function onError(error) {
  const legacyInvalidToken =
    error?.response?.data?.error === 'internal_server_error' &&
    error?.response?.data?.error_description?.includes('/security/oauth/check_token')

  const invalidToken =
    error?.response?.status === 400 &&
    (error?.response?.config?.url?.includes('oauth/check_token') ||
      error?.response?.data?.error === 'invalid_token' ||
      legacyInvalidToken)

  if (error?.response?.status === 401 && error?.response?.data?.error === 'invalid_token') {
    trace.trhowMsg(
      `[trace][2] msg: ${error?.response?.data?.error},
      url: ${error?.response?.config?.url},
      status: ${error?.response?.status}`
    )
    authService.logout(error)
  }

  if (invalidToken) {
    trace.trhowMsg(`[trace][1] msg: ${error?.response?.data?.error}, url: ${error?.response?.config?.url}`)

    clearCookies()
    localStorage.removeItem(LOCALSTORAGE_TOKEN_NAME)
    window.location.href = generateSSOpathLogout()
  }
  return error
}

axios.interceptors.request.use(
  config => {
    config.headers['x-app-name'] = appName
    return config
  },
  error => Promise.reject(error)
)
axios.interceptors.response.use(response => response, onError)
